import { useState } from 'react';
import SearchByVehicleForm from './SearchByVehicleForm';
import MobileDrawer from '@c/drawers/MobileDrawer';
import { UserBike } from 'models/shared';

type MobileSearchByVehicleProps = {
  show: boolean;
  dismiss: () => void;
  onBikeComplete: (bike: UserBike) => void;
};

export default function MobileSearchByVehicle({
  show,
  dismiss,
  onBikeComplete,
}: MobileSearchByVehicleProps) {
  const [searchQuery, setSearchQuery] = useState('');

  return (
    <MobileDrawer title="Find Your Vehicle" show={show} dismiss={dismiss}>
      <div className="flex h-[60rem] flex-col gap-y-6 p-[3rem]">
        <SearchByVehicleForm
          onBikeComplete={onBikeComplete}
          onDismiss={dismiss}
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
        />
      </div>
    </MobileDrawer>
  );
}
